"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SensorSearchTerm = void 0;
const react_1 = __importDefault(require("react"));
const ahooks_1 = require("ahooks");
const DataSearch_1 = __importDefault(require("@appbaseio/reactivesearch/lib/components/search/DataSearch"));
const hooks_1 = require("../../hooks");
const SensorSearchTerm = () => {
  const {
    options,
    config
  } = (0, hooks_1.useReactifySearchContext)();
  const {
    track
  } = (0, hooks_1.useAnalytics)();
  const {
    searchTerm
  } = (0, hooks_1.useSearch)();
  const [searchTermDebounced, setSearchTermDebounced] = react_1.default.useState(searchTerm);
  // ignore search fields only set for instant search
  const searchFields = react_1.default.useMemo(() => {
    if (options.mode === "search") {
      return config.fields.filter(field => ["always_search", "search_page"].includes(field.searchType));
    }
    if (options.mode === "instant-search") {
      return config.fields.filter(field => ["always_search", "instant_search"].includes(field.searchType));
    }
    return [];
  }, [config.fields]);
  const {
    run: runDebouncedTriggerQuery,
    cancel: cancelDebouncedTriggerQuery
  } = (0, ahooks_1.useDebounceFn)(value => {
    setSearchTermDebounced(value);
    if (!value || value && value.length < 3) {
      return;
    }
    track({
      eventName: "search",
      payload: {
        searchTerm: value
      }
    });
  }, {
    wait: 300
  });
  react_1.default.useEffect(() => {
    runDebouncedTriggerQuery(searchTerm);
  }, [searchTerm]);
  if (searchFields.length === 0) {
    return null;
  }
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(DataSearch_1.default, {
    fuzziness: 1,
    queryFormat: "and",
    autosuggest: false,
    value: searchTermDebounced,
    componentId: "SensorSearchTerm",
    style: {
      display: "none"
    },
    dataField: searchFields.map(field => field.field),
    fieldWeights: searchFields.map(field => field.importance),
    customQuery: (value, props) => {
      const {
        dataField,
        fieldWeights
      } = props;
      const fieldsCrossFields = dataField.map((field, index) => `${field}^${fieldWeights[index]}`);
      const fieldsPhrase = dataField.map((field, index) => `${field}^${fieldWeights[index]}`);
      const fieldsPhrasePrefix = dataField.map((field, index) => `${field}^${fieldWeights[index]}`).filter(field => !field.includes("."));
      const fieldsSpanFirst = dataField.filter(field => {
        if (field.endsWith(".keyword")) {
          return false;
        }
        return true;
      }).map(field => ({
        span_first: {
          match: {
            span_term: {
              [`${field}`]: value
            }
          },
          end: 1
        }
      }));
      const query = {
        bool: {
          should: [...(value ? [{
            nested: {
              path: "curations",
              query: {
                term: {
                  "curations.searchTerm.keyword": value.toLowerCase()
                }
              }
            }
          }] : []), ...(fieldsPhrase.length > 0 ? [{
            multi_match: {
              query: value,
              fields: fieldsPhrase,
              type: "phrase",
              operator: "and"
            }
          }] : []), ...(fieldsPhrasePrefix.length > 0 ? [{
            multi_match: {
              query: value,
              fields: fieldsPhrasePrefix,
              type: "phrase_prefix",
              operator: "and"
            }
          }] : []), ...(fieldsCrossFields.length > 0 ? [{
            multi_match: {
              query: value,
              fields: fieldsCrossFields,
              type: "cross_fields",
              operator: "and"
            }
          }] : []), ...(fieldsSpanFirst.length > 0 ? [...fieldsSpanFirst] : [])],
          minimum_should_match: "1"
        }
      };
      return {
        query
      };
    }
  }));
};
exports.SensorSearchTerm = SensorSearchTerm;